import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SecurityContext, OnDestroy, ViewChildren, OnChanges, TemplateRef } from '@angular/core';
import { Subscription, forkJoin } from 'rxjs';
import { ApiService } from '../api.service';
import { ProfileService } from '../profile.service';
import { ImageUploaderComponent } from '../dhhp-image-uploader/image-uploader.component';
import { Location } from '@angular/common'
import { MatDialog } from '@angular/material/dialog';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DialogOverviewComponent } from '../dialog-overview-confirmation/dialog-overview-confirmation.component';
import { PHBHPFeaturePackageAuthorizationService } from 'src/app/Authorization/ph-bhp-feature-package-authorization.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-layout-package.service';
import { PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-listapi.service';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'dhhp-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.css']
})
export class ProfileDetailsComponent implements OnInit, OnDestroy, OnChanges {
  Name;
  mode;
  dataSource;
  currentUserData: any = {};
  @Input() isPlatform: boolean = false;
  @Input() isDisableSetting: boolean = false;
  @Input() userprinciplename;
  @Input() role;
  @Input() institutionname;
  @Input() employeeStatus;
  @Input() clientId;
  selectedIndex: number;
  phone: any;
  name:any;
  email: any;
  salutation: any;
  lastName: any;
  dataToPass: any;
  existingValue;
  existingValueEmail;
  existingValueName;
  submitted = false;
  modalRef : BsModalRef;
  @Input() logOutUrl;
  @Input() clientSecret;
  @Input() userData;
  @Output() dataEvent = new EventEmitter();
  salutationList: string[] = ['Mr.', 'Mrs.', 'Miss.', 'Ms.'];
  @ViewChild('inputModel') inputModel;
  @ViewChild('inputEmailModel') inputEmailModel;
  @ViewChild('lastNameModel') lastNameModel;
  @ViewChild('inputNameModel') inputNameModel;
  @ViewChild('confirmModal') confirmModal: TemplateRef<any>;
  defaultuserIcon;
  hideEditVal: boolean = false;
  subscription: Subscription;
  subscription_img: Subscription;
  subscription_lang: Subscription;
  subscription_template: Subscription;
  subscription_policy : Subscription;
  getAccountData: any;
  selectIndex: any;
  imageUrl;
  imm;
  passListData;
  profileName: string;
  isNotFound = false;
  isNotHartmannUser: boolean = true;
  @ViewChild('imageUploaderComp') imageUploaderComp: ImageUploaderComponent;
  columnsToDisplay = ['appName', 'appRole'];
  htmlToAddTerms: any;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  
  constructor(public dialog: MatDialog, private apiService: ApiService, private modalService: BsModalService, private sanitizer: DomSanitizer, private service: PHBHPFeaturePackageAuthorizationService, public layoutService: PHBHPLayoutPackageService, private service_listApi: PHBHPListApiService,  private userService: ProfileService, private location: Location) { }

  ngOnInit() {
    this.defaultuserIcon = this.userService.defaultuserIcon;
    this.mode = "View";
    this.subscription = this.userService.profileTabIndex$.subscribe((data) => {
      this.selectIndex = data;
      this.selectedIndex = this.selectIndex;
      this.dataEvent.emit({ event: "actionfound", value: data });
    });
    this.subscription_img = this.userService.completeUserData$.subscribe(res => {
      this.imageUrl = res.profileImage;
    })
  }
  ngOnChanges() {
    this.imm = this.userService.hartmannIcon;
    if(this.userData){
      this.currentUserData = this.userData;
      this.passListData = this.userData;
      this.existingValue = this.currentUserData.phone;
      this.existingValueEmail = this.currentUserData.email;
      this.existingValueName = this.currentUserData.name;
      this.profileName = this.passListData.name.charAt(0);
      var templateType = "T&C";
      var selectedlanguage = localStorage.getItem('selectedlanguage');
      this.getTemplate(templateType, selectedlanguage);
      this.subscription_lang = this.layoutService.lang.asObservable().subscribe(
        (language) => {
          this.getTemplate(templateType, language);
        }
      )
      this.email = new String(this.currentUserData.email);
      this.name = new String(this.currentUserData.name);
    }
    // if (this.userprinciplename)
    //   this.apiService.getUserProfile(this.userprinciplename).subscribe(res => {
    //     this.currentUserData = res;
    //     this.existingValue = this.currentUserData.phone;
    //     this.existingValueEmail = this.currentUserData.email;
    //     this.dataSource = new MatTableDataSource<any>(res.appList);
    //     this.passListData = res;
    //     this.profileName = this.passListData.firstName.charAt(0) + '' + this.passListData.lastName.charAt(0);
    //     if (this.passListData.profileImage && this.passListData.profileImage != '') {
    //       this.imageUrl = this.passListData.profileImage;
    //     }
    //     if (res.appList.length == 0) {
    //       this.isNotFound = true;
    //     }
    //     if (res.userType == 'Hartmann' || res.userType == 'Developer') {
    //       this.isNotHartmannUser = false;
    //       this.userService.userTypeValue.next(res.userType);
    //     }
    //     if (this.currentUserData.facilityAccounts.length) {
    //       this.getAccountData = this.currentUserData.facilityAccounts;
    //     }
    //   })
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscription_img) {
      this.subscription_img.unsubscribe();
    }
    if (this.subscription_lang) {
      this.subscription_lang.unsubscribe();
    }
    if (this.subscription_template) {
      this.subscription_template.unsubscribe();
    }
    if (this.subscription_policy) {
      this.subscription_policy.unsubscribe();
    }
  }

  getTemplate(templateType, selectedlanguage) {
    this.subscription_template = this.service.getTemplate(templateType, selectedlanguage).subscribe((res: any) => {
      this.htmlToAddTerms = this.sanitizer.sanitize(SecurityContext.HTML, res.content);
    });
  }
  
  onEdit() {
    this.mode = "Edit";
    this.hideEditVal = true;
    this.submitted = false;
    this.phone = this.currentUserData.phone;
    this.email = this.currentUserData.email;
    this.name = this.currentUserData.name;
    this.lastName = this.currentUserData.lastName;
    this.salutation = this.currentUserData.salutation;
    //this.UserImg = this.currentUserData.ProfileImgPath;
    //if(!!this.UserImg){
    //this.careProService.changeProfileImage(this.UserImg)          
    //}else{
    //this.careProService.changeProfileImage("");
    //}
  }

  onBack() {
    this.location.back();
    this.hideEditVal = false;
  }

  getCompleteUserData() {
    this.userService.completeUserData$.subscribe({
      next: data => {
        this.currentUserData = data;
      },
      error: err => { },
      complete: () => { }
    })
  }
  onCancel(event) {
    this.mode = "View";
    //event.preventDefault();
    this.hideEditVal = false;
    this.email = new String(this.currentUserData.email);
    this.name = new String(this.currentUserData.name);
  }
  onDataEvent(event) {
    this.dataEvent.emit(event);
  }

  redirectToProfile(index) {
    if(index == 6 && !this.isNotHartmannUser){
      return false;
    }
    this.userService.profileTabIndex.next(index);
    this.selectedIndex = index;
    //this.router.navigateByUrl(`/${this.profileUrl}`);
  }
  showConfirmationPopup(confirmModal) {
    this.modalRef = this.modalService.show(confirmModal, Object.assign({}, { class: 'w-420' }))
  }
  logout() {
    this.userService.logout();
    window.location.href = this.logOutUrl;
  }
  decline() {
    this.subscription_policy = this.service_listApi.deleteTermsAndconditions(this.currentUserData.userId, false).subscribe(
      (data) => {},
      (err) => {}, 
      ()=> {
        this.logout();
      });
  }
  updateProfileDetails() {
    const dialogRef = this.dialog.open(DialogOverviewComponent, {
      width: '500px',
      disableClose: true
    });
    this.dataToPass = {
      profileUpdate: true,
    };
    dialogRef.componentInstance.confirmData = this.dataToPass;
    dialogRef.componentInstance.username = this.currentUserData.username;
    dialogRef.afterClosed().subscribe(result => {
      if (result.event === 'profileMoify') {
        //this.OnUpdateProfile('');
        this.mhsUpload();
      } else if (result.event === 'profileMoifyError') {
        this.dataEvent.emit({ event: "profileUpdateError", value: result.message });
      }
    });
  }
  onSave(event, imageFile) {

    event.preventDefault();
    this.submitted = true;
    var attributeInvalid = false;
    if (this.inputNameModel.invalid) {
      attributeInvalid = true;
      return false;
    }
    if (this.inputEmailModel.invalid) {
      attributeInvalid = true;
      return false;
    }
    // if (this.lastNameModel.invalid) {
    //   attributeInvalid = true;
    //   return false;
    // }
    if (attributeInvalid) {
      return false;
    }
    if (this.existingValue != this.phone || this.existingValueEmail != this.email || this.existingValueName != this.name) {
      this.updateProfileDetails();
    } else {
      //this.OnUpdateProfile('');
      this.mhsUpload();
    }
    // if (this.imageUploaderComp.imageErrorMessage != undefined &&  this.imageUploaderComp.imageErrorMessage != '') {
    //   return;
    // }

  }
  OnUpdateProfile(imageFile) {
    const fileFormDetails = {
      userId: this.userprinciplename,
      phone: this.phone,
      salutation: this.salutation,
      email: this.email,
      lastName: this.lastName
    }
    var Response: Array<any> = [];
    Response[0] = this.apiService.uploadUserProfileDetails(fileFormDetails);
    if (imageFile !== undefined && imageFile.imagePath) {
      const fileFormData = new FormData();
      fileFormData.append('Image', imageFile.imagePath[0]);
      fileFormData.append('UserId', this.userprinciplename);
      Response[1] = this.apiService.uploadUserProfileImage(fileFormData);
    }
    forkJoin(Response).subscribe({
      next: ([resAllData, resImageDetail]) => {
        if (resImageDetail) {
          this.currentUserData.profileImage = resImageDetail;
          this.userService.changeCompleteUserData(this.currentUserData);
        }
        this.currentUserData.phone = this.phone;
        this.currentUserData.email = this.email;
        this.hideEditVal = false;
        this.currentUserData.lastName = this.lastName;
        this.currentUserData.salutation = this.salutation;
        this.existingValue = this.phone;
        this.existingValueEmail = this.email;
        this.existingValueName = this.name;
        this.mode = "View";
        this.submitted = false;
        this.dataEvent.emit({ event: "profileUpdateSuccess" });
      },
      error: err => {
        if (err.error.message != '') {
          this.dataEvent.emit({ event: 'error', message: err.error.message })
        }
      },
      complete: () => { }
    })
  }
  mhsUpload() {
    var data = {
      "name" : this.name,
      "email" :  this.email,
      "userId" : this.userData.userId
    }
    this.layoutService.showLoader = true;
    this.apiService.mhsProfileUpdate(data).subscribe({
      next: (res) => {
        this.layoutService.showLoader = false;
        this.currentUserData.phone = this.phone;
        this.currentUserData.email = this.email;
        this.currentUserData.name = this.name;
        this.userData.name = this.name;
        this.hideEditVal = false;
        this.currentUserData.lastName = this.lastName;
        this.currentUserData.salutation = this.salutation;
        this.existingValue = this.phone;
        this.existingValueEmail = this.email;
        this.existingValueName =this.name;
        this.mode = "View";
        this.submitted = false;
        this.dataEvent.emit({ event: "profileUpdateSuccess" });
      },
      error: err => {
        this.layoutService.showLoader = false;
        if (err.error.message != '') {
          this.dataEvent.emit({ event: 'error', message: err.error.message })
        }
      },
      complete: () => {
        this.layoutService.showLoader = false;
      }
    });
  }
  changeNameText(text){ 
    if(!text) delete this.name;
  }
  changeEmailText(text){ 
    if(!text) delete this.email;
  }
  
}